export default class CreateConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(payload) {
    try {
      const result = await this.#repository.createConvocatoria(payload)
      return result
    } catch (error) {
      console.error('Error al crear la convocatoria:', error)
      throw error
    }
  }
}
